import { createContext } from "react";

const DesignationContext = createContext();

export default DesignationContext;